export const common = {
  // Navigation
  "nav.service": "Service",
  "nav.accessTiers": "Access Tiers",
  "nav.philosophy": "Philosophy",
  "nav.requestAccess": "Request Access",

  // Hero
  "hero.badge": "Invitation Only",
  "hero.title1": "Private Access to",
  "hero.title2": "the Future of",
  "hero.title3": "Home Robotics",
  "hero.subtitle":
    "An exclusive concierge service for those who want priority access, expert guidance, and seamless adoption of next-generation domestic robots—when they become available.",
  "hero.cta1": "Request Priority Access",
  "hero.cta2": "Join the Private List",

  // Social Proof
  "social.text":
    "Designed for a limited number of clients who value discretion, time, and early access to transformative technologies.",

  // Scarcity & Pain Points
  "scarcity.label": "Market Reality",
  "scarcity.title": "Without Priority Access, You Risk Waiting Years",
  "scarcity.subtitle": "Advanced domestic robots won't be available to everyone. Here's why privileged access changes everything.",
  "scarcity.pain1.title": "Endless Waiting Lists",
  "scarcity.pain1.desc": "First consumer models will have 18-36 month waiting lists. Without priority, you'll be behind thousands of others.",
  "scarcity.pain2.title": "Complex Purchase Processes",
  "scarcity.pain2.desc": "Lottery systems, hour-long order windows, opaque procedures. Most people will miss their chance.",
  "scarcity.pain3.title": "Fragmented Information",
  "scarcity.pain3.desc": "Availability announcements happen without notice, across scattered channels. You'll learn about order openings... after they close.",
  "scarcity.pain4.title": "Unpredictable Pricing",
  "scarcity.pain4.desc": "Early pricing can fluctuate 40% depending on timing and purchase channel. Without monitoring, you'll pay premium prices.",
  "scarcity.solution": "Our members avoid these obstacles. They're alerted first, guided through every step, and positioned at the front of the line.",

  // How It Works
  "how.label": "The Process",
  "how.title": "Seamless Priority Access",
  "how.step1.title": "Join the Private Priority List",
  "how.step1.desc":
    "Submit your application for exclusive membership. Our team reviews each request to ensure alignment with our service standards.",
  "how.step2.title": "Receive Curated Updates",
  "how.step2.desc":
    "Get early alerts on emerging technologies, product launches, and availability windows before the general public.",
  "how.step3.title": "Assisted Access When Available",
  "how.step3.desc":
    "Navigate complex acquisition processes with expert guidance, ensuring you secure priority access without friction.",
  "how.step4.title": "White-Glove Support",
  "how.step4.desc":
    "Optional installation, configuration, and ongoing technical support to ensure seamless integration into your home.",

  // Value Proposition
  "value.title": "Investment Transparency",
  "value.subtitle": "Your membership covers exclusive services, not product sales.",
  "value.b1.title": "Priority Access & Alerts",
  "value.b1.desc": "Be first in line when new technologies become available",
  "value.b2.title": "Independent Technology Monitoring",
  "value.b2.desc": "Unbiased tracking of emerging domestic robotics landscape",
  "value.b3.title": "Assisted Acquisition Process",
  "value.b3.desc": "Expert guidance through complex purchasing procedures",
  "value.b4.title": "Concierge-Level Support",
  "value.b4.desc": "Dedicated assistance tailored to your specific needs",
  "value.b5.title": "Optional Installation & Configuration",
  "value.b5.desc": "Professional setup and integration services available",
  "value.disclaimer": "This service does not sell robots and is not affiliated with any manufacturer.",

  // Pricing
  "pricing.label": "Access Tiers",
  "pricing.title": "Choose Your Level of Priority",
  "pricing.elite": "Elite Access",
  "pricing.premium": "Premium Concierge",
  "pricing.founders": "Founders Circle",
  "pricing.limited": "Limited Availability",
  "pricing.fee": "One-time service fee",
  "pricing.select": "Select Tier",
  "pricing.apply": "Apply Now",
  "pricing.note": "Fees apply to services only. No product sales. Fully transparent.",
  "pricing.e1": "Priority list membership",
  "pricing.e2": "Quarterly technology updates",
  "pricing.e3": "Early product alerts",
  "pricing.e4": "Email support",
  "pricing.e5": "Access to member resources",
  "pricing.e6": "Acquisition guidance",
  "pricing.e7": "Market intelligence reports",
  "pricing.e8": "Community forum access",
  "pricing.p1": "All Elite Access benefits",
  "pricing.p2": "Monthly personalized briefings",
  "pricing.p3": "Dedicated concierge contact",
  "pricing.p4": "Priority phone support",
  "pricing.p5": "Assisted acquisition process",
  "pricing.p6": "Installation coordination",
  "pricing.p7": "Technical consultation (2 hours)",
  "pricing.p8": "Exclusive event invitations",
  "pricing.p9": "Extended support period",
  "pricing.f1": "All Premium Concierge benefits",
  "pricing.f2": "White-glove installation service",
  "pricing.f3": "Unlimited technical support",
  "pricing.f4": "Personal technology advisor",
  "pricing.f5": "First-access guarantee",
  "pricing.f6": "Custom integration planning",
  "pricing.f7": "Annual home technology audit",
  "pricing.f8": "VIP event access",
  "pricing.f9": "Lifetime priority status",
  "pricing.f10": "Concierge hotline (24/7)",

  // Philosophy
  "phil.label": "Our Philosophy",
  "phil.main":
    "As advanced domestic robots approach real-world availability, access will be limited, complex, and time-sensitive. This service exists to remove friction and ensure our clients are always first—without stress.",
  "phil.p1":
    "We maintain complete independence from all manufacturers and brands. Our sole commitment is to our clients—providing unbiased guidance, transparent information, and priority positioning in an emerging market.",
  "phil.p2":
    "This is not about selling products. It's about providing the expertise, access, and peace of mind that comes with having a dedicated technology concierge who understands both the innovations and your unique needs.",

  // Trust & Legal
  "trust.t1.title": "Independent Service",
  "trust.t1.desc":
    "No manufacturer affiliations or brand partnerships. Our recommendations are unbiased and client-focused.",
  "trust.t2.title": "No Product Guarantees",
  "trust.t2.desc":
    "We provide access services only. Product availability and specifications are determined by manufacturers.",
  "trust.t3.title": "Transparent Pricing",
  "trust.t3.desc":
    "Clear, upfront service fees with no hidden costs. You pay for expertise and priority access, not products.",
  "trust.t4.title": "Fair Refund Policy",
  "trust.t4.desc":
    "Service satisfaction guaranteed. Review our terms for complete refund policy details and conditions.",

  // Final CTA
  "cta.title1": "Be Ready Before",
  "cta.title2": "the World Is",
  "cta.subtitle":
    "Priority access is intentionally limited to maintain service quality and exclusivity.",
  "cta.formTitle": "Priority Access Application",
  "cta.fullName": "Full Name",
  "cta.email": "Email Address",
  "cta.phone": "Phone Number",
  "cta.tier": "Preferred Access Tier",
  "cta.message": "Tell us about your interest (Optional)",
  "cta.namePlaceholder": "Enter your full name",
  "cta.emailPlaceholder": "your@email.com",
  "cta.phonePlaceholder": "+1 (555) 000-0000",
  "cta.messagePlaceholder":
    "What are you most interested in? Any specific requirements?",
  "cta.submit": "Apply for Priority Access",
  "cta.submitting": "Submitting...",
  "cta.success": "Application submitted successfully! We'll be in touch soon.",
  "cta.error": "Something went wrong. Please try again.",
  "cta.limited": "Places are intentionally limited.",
  "cta.chars": "characters",

  // Footer
  "footer.tagline":
    "Exclusive priority access to next-generation domestic robotics",
  "footer.legal": "Legal",
  "footer.legalNotice": "Legal Notice",
  "footer.terms": "Terms of Service",
  "footer.privacy": "Privacy Policy",
  "footer.agreement": "Service Agreement",
  "footer.contact": "Contact",
  "footer.contactConcierge": "Contact Concierge",
  "footer.copyright": "\u00a9 2026 NOKX GLOBAL LTD. All rights reserved.",

  // Language
  "lang.en": "English",
  "lang.fr": "Fran\u00e7ais",

  // Legal Notice Page
  "legal.backHome": "Back to Home",
  "legal.label": "Legal Information",
  "legal.title": "Legal Notice",
  "legal.lastUpdated": "Last updated",
  "legal.allRightsReserved": "All rights reserved.",
  "legal.companyInfo": "Company Information",
  "legal.companyName": "Company Name",
  "legal.companyNumber": "Company Number",
  "legal.companyType": "Company Type",
  "legal.privateLimited": "Private Limited Company",
  "legal.incorporatedOn": "Incorporated On",
  "legal.registeredAddress": "Registered Office Address",
  "legal.companyStatus": "Company Status",
  "legal.active": "Active",
  "legal.businessActivity": "Nature of Business (SIC)",
  "legal.sicDescription": "Retail sale via mail order houses or via Internet",
  "legal.servicesTitle": "Nature of Services",
  "legal.servicesP1": "NOKX GLOBAL LTD operates a private technology concierge service providing priority access, expert guidance, and assisted acquisition services for next-generation domestic robotics and home automation technologies.",
  "legal.servicesP2": "Our service includes membership-based access tiers offering technology monitoring, personalised briefings, acquisition assistance, installation coordination, and ongoing technical support.",
  "legal.servicesDisclaimer": "Important: This service does not sell, manufacture, or distribute robots or any physical products. We are an independent concierge service with no manufacturer affiliations. All fees relate exclusively to our advisory and access services.",
  "legal.ipTitle": "Intellectual Property",
  "legal.ipP1": "All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of NOKX GLOBAL LTD and is protected by United Kingdom and international copyright laws.",
  "legal.ipP2": "No part of this website may be reproduced, distributed, or transmitted in any form without the prior written permission of NOKX GLOBAL LTD.",
  "legal.liabilityTitle": "Limitation of Liability",
  "legal.liabilityP1": "The information provided on this website is for general informational purposes only. While we strive to keep the information accurate and up to date, NOKX GLOBAL LTD makes no representations or warranties of any kind about the completeness, accuracy, or reliability of the information.",
  "legal.liabilityP2": "NOKX GLOBAL LTD shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services or this website.",
  "legal.liabilityP3": "Product availability, specifications, pricing, and release dates mentioned on this website are subject to change by their respective manufacturers and are provided for informational purposes only.",
  "legal.privacyTitle": "Data Protection & Privacy",
  "legal.privacyP1": "NOKX GLOBAL LTD is committed to protecting your personal data in accordance with the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018. We collect and process personal data only as necessary to provide our services.",
  "legal.privacyL1": "We collect personal information you voluntarily provide, such as your name, email address, phone number, and service preferences.",
  "legal.privacyL2": "Your data is used solely to process your membership application, deliver our concierge services, and communicate relevant updates.",
  "legal.privacyL3": "We do not sell, rent, or share your personal information with third parties for marketing purposes.",
  "legal.privacyL4": "You have the right to access, rectify, erase, or restrict the processing of your personal data at any time by contacting us.",
  "legal.privacyP2": "Payment processing is handled securely by Stripe, a PCI-DSS compliant payment processor. We do not store your payment card details on our servers.",
  "legal.paymentTitle": "Payment Terms",
  "legal.paymentP1": "All service fees are one-time payments in Euros (\u20ac) and are clearly displayed before purchase. Payments are processed securely through Stripe. By completing a purchase, you agree to the applicable service tier terms.",
  "legal.paymentP2": "Prices are inclusive of all applicable taxes unless otherwise stated. NOKX GLOBAL LTD reserves the right to modify pricing for future memberships with reasonable notice.",
  "legal.refundTitle": "Refund Policy",
  "legal.refundP1": "If you are not satisfied with our service, you may request a refund within 14 days of your purchase, provided that no substantive service has been delivered. Refund requests should be sent to our contact email.",
  "legal.refundP2": "After the 14-day period, or once substantive service delivery has commenced, refunds will be assessed on a case-by-case basis at the discretion of NOKX GLOBAL LTD.",
  "legal.governingTitle": "Governing Law",
  "legal.governingP1": "These terms and all matters arising from or related to the use of this website and our services shall be governed by and construed in accordance with the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.",
  "legal.contactTitle": "Contact Us"
};
